module.exports = __webpack_public_path__ + "static/media/menu-down.011d2f9d.svg";